var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2f245a",
    width: "25pt",
    height: "25pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m135.77 170.2h22.664v-36.441c0-6.1836 5.0234-11.207 11.207-11.207h37.664v-81.516c0-6.1836 5.0234-11.207 11.207-11.207h262.96c6.1836 0 11.207 5.0234 11.207 11.207v81.516h37.684c6.1836 0 11.207 5.0234 11.207 11.207v36.441h22.664c14.012 0 26.781 5.7617 36.055 15.02l0.066407 0.066406c9.2383 9.2734 15.004 22.043 15.004 36.035v179.91c0 14.027-5.7617 26.812-15.004 36.07-9.3086 9.2891-22.094 15.055-36.105 15.055h-71.535v66.613c0 6.1836-5.0234 11.207-11.207 11.207h-262.96c-6.1836 0-11.207-5.0234-11.207-11.207v-66.613h-71.535c-14.027 0-26.812-5.7617-36.07-15.004-9.2891-9.3086-15.055-22.074-15.055-36.105v-179.91c0-14.062 5.7617-26.848 15.02-36.105s22.043-15.004 36.105-15.004zm321.36 49.645c-8.1484 0-14.816 6.668-14.816 14.816 0 8.1484 6.6523 14.816 14.816 14.816 8.1484 0 14.816-6.668 14.816-14.816 0-8.1484-6.668-14.816-14.816-14.816zm45.211 0c-8.1484 0-14.816 6.6523-14.816 14.816 0 8.1484 6.6523 14.816 14.816 14.816 8.1484 0 14.816-6.6523 14.816-14.816 0-8.1484-6.6523-14.816-14.816-14.816zm45.211 0c-8.1484 0-14.816 6.6523-14.816 14.816 0 8.1484 6.6523 14.816 14.816 14.816 8.1484 0 14.816-6.6523 14.816-14.816 0-8.1484-6.6523-14.816-14.816-14.816zm-282.31 206.17c-6.1836 0-11.207-5.0234-11.207-11.207s5.0234-11.207 11.207-11.207h169.5c6.1836 0 11.207 5.0234 11.207 11.207s-5.0234 11.207-11.207 11.207zm0 67.922c-6.1836 0-11.207-5.0234-11.207-11.207s5.0234-11.207 11.207-11.207h121.75c6.1836 0 11.207 5.0234 11.207 11.207s-5.0234 11.207-11.207 11.207zm0-33.953c-6.1836 0-11.207-5.0234-11.207-11.207s5.0234-11.207 11.207-11.207h169.5c6.1836 0 11.207 5.0234 11.207 11.207s-5.0234 11.207-11.207 11.207zm-57.926-70.191h-10.031v40.137h10.031zm-32.441 40.137v-51.34c0-6.1836 5.0234-11.207 11.207-11.207h327.82c6.1836 0 11.207 5.0234 11.207 11.207v51.34h39.109c7.8945 0 15.086-3.2422 20.293-8.418 5.1758-5.1914 8.418-12.398 8.418-20.293v-179.91c0-7.9141-3.2266-15.086-8.3984-20.262-5.207-5.2266-12.398-8.4336-20.312-8.4336h-428.44c-7.8945 0-15.07 3.2422-20.277 8.4336-5.207 5.207-8.4336 12.383-8.4336 20.277v179.91c0 7.8945 3.2422 15.086 8.418 20.293 5.1914 5.1758 12.398 8.418 20.293 8.418h39.109zm327.82 0v-40.137h-10.012v40.137zm-32.426-40.137h-240.54v117.95h240.54zm-240.54-219.58h240.54v-117.95h-240.54zm-48.871 0h26.461v-25.234h-26.461zm311.83 0h26.477v-25.234h-26.477zm-199.54 43.277c6.1836 0 11.207 5.0234 11.207 11.207s-5.0234 11.207-11.207 11.207h-32.711c-6.1836 0-11.207-5.0234-11.207-11.207s5.0234-11.207 11.207-11.207zm-67.418 0c6.1836 0 11.207 5.0234 11.207 11.207s-5.0234 11.207-11.207 11.207h-73.871v81.566c0 6.1836-5.0234 11.207-11.207 11.207s-11.207-5.0234-11.207-11.207v-92.77c0-6.1836 5.0234-11.207 11.207-11.207h85.074z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 585.199219,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 76.164062,
    y: 585.199219,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 80.308594,
    y: 585.199219,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 86.003906,
    y: 585.199219,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 91.671875,
    y: 585.199219,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.6875,
    y: 585.199219,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 101.386719,
    y: 585.199219,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 110.324219,
    y: 585.199219,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 116.335938,
    y: 585.199219,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 124.734375,
    y: 585.199219,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 130.089844,
    y: 585.199219,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 132.96875,
    y: 585.199219,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 138.980469,
    y: 585.199219,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144.679688,
    y: 585.199219,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 148.820312,
    y: 585.199219,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.800781,
    y: 585.199219,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 593.601562,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 73.65625,
    y: 593.601562,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 77.796875,
    y: 593.601562,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 83.566406,
    y: 593.601562,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.246094,
    y: 593.601562,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 99.261719,
    y: 593.601562,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 105.242188,
    y: 593.601562,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 113.863281,
    y: 593.601562,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120.894531,
    y: 593.601562,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 126.664062,
    y: 593.601562,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 132.644531,
    y: 593.601562,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 141.546875,
    y: 593.601562,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 147.703125,
    y: 593.601562,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 151.847656,
    y: 593.601562,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 157.617187,
    y: 593.601562,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 160.496094,
    y: 593.601562,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 166.195312,
    y: 593.601562,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 171.175781,
    y: 593.601562,
    xlinkHref: "#c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPrint);
export default __webpack_public_path__ + "static/media/noun-print.6dd339757f66d01b6012219adafbb572.svg";
export { ForwardRef as ReactComponent };